import ApplyRetailCreditServiceApi from '../../api/apply-retail-credit-service-api'
import { LOAD_APPLICATION_LINKS } from './action-types'

export const getApplicationLinksForStoreSuccess = applicationLinks => ({
  type: LOAD_APPLICATION_LINKS,
  applicationLinks,
})

export const getApplicationLinksForStore = (storeId, token) => {
  return ApplyRetailCreditServiceApi.fetchLinksByStoreId(storeId, token)
}
